import 'leaflet'
import 'leaflet-svg-shape-markers'
import 'leaflet-outline-connector'
import 'leaflet-semirings'
import './plugins/leaflet-svg-icon'


const L = window.L
export default L